import React from 'react';
import classnames from 'classnames';

import styles from './text.module.scss';

const baseClass = 'text';

export type TextProps = {
  tag?: 'p' | 'span';
  withShadow?: boolean;
  variant?:
    | 'caption-100'
    | 'caption-200'
    | 'caption-200-fixed'
    | 'caption-300'
    | 'caption-300-fixed'
    | 'caption-400-fixed'
    | 'label-100'
    | 'label-200'
    // Paragraphs [P]
    | 'P-300'
    | 'P-200'
    | 'P-100'
    // Legal [LGL]
    | 'LGL-100'
    // Depreciated
    | 'paragraph-100'
    | 'paragraph-200'
    | 'paragraph-300'
    | 'legal-100';
} & Pick<React.HTMLAttributes<HTMLParagraphElement>, 'children' | 'className' | 'id'>;

export const Text: React.FC<TextProps> = ({
  children,
  className,
  tag = 'p',
  id,
  variant = 'paragraph-100',
  withShadow
}) => {
  const classes = classnames(
    styles.text,
    styles[`${baseClass}--${variant}`],
    { [styles[`${baseClass}--${variant}--with-shadow`]]: withShadow },
    className
  );
  const Tag = tag;
  return (
    <Tag className={classes} id={id}>
      {children}
    </Tag>
  );
};
